import { EventEmitter, inject, TemplateRef } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { IS_MODAL_VIEW, MAX_VIEW_DEPTH } from 'FoldersApp/constants/folderable-app-config.constants';
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { FolderExpansionService } from 'FoldersApp/services/folder-expansion-service/folder-expansion.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { ItemSelectionService } from 'NewAngular/services/item-selection.service';
import { FolderableBase } from 'FoldersApp/directives/folderable-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/bulk-action-selection.service";
import * as i2 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i3 from "FoldersApp/services/folder-expansion-service/folder-expansion.service";
import * as i4 from "NewAngular/services/item-selection.service";
import * as i5 from "../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i9 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i10 from "FoldersApp/features/folders-shared/set-view-root-folder/set-view-root-folder.directive";
import * as i11 from "../../../../../sharing/static/sharing/ts/pipes/get-sharing-tooltip-message.pipe";
import * as i12 from "../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _c0 = a0 => ({ folder: a0 });
const _c1 = a0 => ({ "show": a0 });
const _c2 = (a0, a1, a2) => ({ id: a0, name: a1, permissions: a2 });
const _c3 = (a0, a1) => ({ folderable: a0, ancestorInfo: a1 });
function _forTrack0($index, $item) { return this.trackFolderable($item); }
function FolderBaseComponent_Conditional_0_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function FolderBaseComponent_Conditional_0_Conditional_7_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.folderToggleHandler()); });
    i0.ɵɵelement(1, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1, ctx_r1.folderExpansionService.isExpanded(ctx_r1.folder.id)));
} }
function FolderBaseComponent_Conditional_0_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 11);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.folderNameFragment)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, ctx_r1.folder));
} }
function FolderBaseComponent_Conditional_0_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 16);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("disabled", !(ctx_r1.folder.permissions == null ? null : ctx_r1.folder.permissions.canView));
    i0.ɵɵproperty("textContent", ctx_r1.folder.name)("folderId", ctx_r1.folder.id);
} }
function FolderBaseComponent_Conditional_0_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵpipe(1, "getSharingTooltipMessage");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", i0.ɵɵpipeBind1(1, 4, ctx_r1.folder));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-team");
} }
function FolderBaseComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function FolderBaseComponent_Conditional_0_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.folderableClickHandler($event)); });
    i0.ɵɵelementStart(1, "div", 2)(2, "label", 3)(3, "input", 4);
    i0.ɵɵlistener("click", function FolderBaseComponent_Conditional_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.bulkActionSelectionService.toggleSelectedItem(ctx_r1.folderable.resourceType, ctx_r1.folder.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 6)(6, "div", 7);
    i0.ɵɵconditionalCreate(7, FolderBaseComponent_Conditional_0_Conditional_7_Template, 2, 3, "div", 8);
    i0.ɵɵelementStart(8, "div", 9);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(10, FolderBaseComponent_Conditional_0_Conditional_10_Template, 1, 4, "ng-container", 11)(11, FolderBaseComponent_Conditional_0_Conditional_11_Template, 1, 4, "a", 12);
    i0.ɵɵconditionalCreate(12, FolderBaseComponent_Conditional_0_Conditional_12_Template, 3, 6, "div", 13);
    i0.ɵɵpipe(13, "isSharedWithOthers");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementContainer(14, 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("bg-yc-blue-90", ctx_r1.isBulkSelected);
    i0.ɵɵproperty("folderable", ctx_r1.folderable)("ancestorInfo", ctx_r1.ancestorInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.isBulkSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isBulkSelected);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.isExpandable ? 7 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-folder");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.folderNameFragment ? 10 : 11);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(13, 12, ctx_r1.folder) ? 12 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.folderColumnDataFragment)("ngTemplateOutletContext", i0.ɵɵpureFunction1(14, _c0, ctx_r1.folder));
} }
function FolderBaseComponent_Conditional_2_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 17);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyFolderFragment);
} }
function FolderBaseComponent_Conditional_2_Conditional_1_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementContainer(1, 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const folderable_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r1.folderExpansionService.getCssClasses(folderable_r4))("id", ctx_r1.folderExpansionService.getId(folderable_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.listItemFragment)("ngTemplateOutletContext", i0.ɵɵpureFunction2(8, _c3, folderable_r4, i0.ɵɵpureFunction3(4, _c2, ctx_r1.folder.id, ctx_r1.folder.name, ctx_r1.folder.permissions)));
} }
function FolderBaseComponent_Conditional_2_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵrepeaterCreate(1, FolderBaseComponent_Conditional_2_Conditional_1_For_2_Template, 2, 11, "div", 20, _forTrack0, true);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("disabled", ctx_r1.isBulkSelected)("pointer-events-none", ctx_r1.isBulkSelected)("opacity-50", ctx_r1.isBulkSelected);
    i0.ɵɵproperty("id", "folder-" + ctx_r1.folder.id + "-nested-children");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.folder.items);
} }
function FolderBaseComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FolderBaseComponent_Conditional_2_Conditional_0_Template, 1, 1, "ng-container", 17)(1, FolderBaseComponent_Conditional_2_Conditional_1_Template, 3, 7, "div", 18);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.folder.items && ctx_r1.folder.items.length === 0 ? 0 : 1);
} }
export class FolderBaseComponent extends FolderableBase {
    get folder() {
        if (this.folderable.resourceType !== 'folder') {
            throw new Error('TypeError: `folderItem` should be a folder.');
        }
        return this.folderable.item;
    }
    get isExpandable() {
        if (this.folderable.viewDepth > this.maxViewDepth - 1)
            return false;
        return !this.folderableCollectionService.textSearchActive;
    }
    constructor(bulkActionSelectionService, folderableCollectionService, folderExpansionService, itemSelectionService) {
        super();
        this.bulkActionSelectionService = bulkActionSelectionService;
        this.folderableCollectionService = folderableCollectionService;
        this.folderExpansionService = folderExpansionService;
        this.itemSelectionService = itemSelectionService;
        this.maxViewDepth = MAX_VIEW_DEPTH;
        this.folderableClick = new EventEmitter();
        this.isModalView = inject(IS_MODAL_VIEW, { optional: true }) ?? false;
    }
    ngOnInit() {
        if (this.itemSelectionService) {
            // If any sub items are selected, expand the folder on load
            const hasSelectedItem = this.folder.items.some((folderable) => this.itemSelectionService.isSelected(folderable.item));
            if (hasSelectedItem) {
                this.folderToggleHandler();
            }
        }
    }
    folderToggleHandler() {
        if (this.folder === null)
            return;
        this.folderExpansionService.toggle(this.folder.id, this.ancestorInfo.id);
        // There seems to be a change detection bug.
        // changeDetectionRef.detectChanges() does not detect changes for sub-folder components.
        // Replace `folderItem` with a new reference to force change detection.
        this.folderable = cloneDeep(this.folderable);
    }
    folderableClickHandler(event) {
        // Ignore the click when a button child of the folder item wrapper element was clicked.
        if (event.target.closest('.btn') !== null)
            return;
        this.folderableClick.emit(this.folderable);
    }
    trackFolderable(folderable) {
        const { resourceType, item } = folderable;
        let unique_id;
        if ('id' in item) {
            unique_id = item.id;
        }
        else if ('name' in item) {
            unique_id = item.name;
        }
        else {
            unique_id = btoa(JSON.stringify(item));
        }
        return `${resourceType}-${unique_id}`;
    }
}
FolderBaseComponent.ɵfac = function FolderBaseComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderBaseComponent)(i0.ɵɵdirectiveInject(i1.BulkActionSelectionService), i0.ɵɵdirectiveInject(i2.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i3.FolderExpansionService), i0.ɵɵdirectiveInject(i4.ItemSelectionService, 8)); };
FolderBaseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderBaseComponent, selectors: [["ycn-folder-base"]], inputs: { folderColumnDataFragment: "folderColumnDataFragment", listItemFragment: "listItemFragment", emptyFolderFragment: "emptyFolderFragment", folderNameFragment: "folderNameFragment", maxViewDepth: "maxViewDepth" }, outputs: { folderableClick: "folderableClick" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [["ycn-folderable", "", 1, "tr", 3, "bg-yc-blue-90", "folderable", "ancestorInfo"], ["ycn-folderable", "", 1, "tr", 3, "click", "folderable", "ancestorInfo"], [1, "td-checkbox", "pt-1", "pb-1"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "td", "file-td-name"], [1, "file-name", "file-td-wrap", "pt-1", "pb-1"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "category-toggler", 3, "ngClass"], [1, "file-icon", "pt-1", "pb-1"], ["ycnIcon", "", 3, "name"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["draggable", "false", "href", "javascript:void(0)", "ycn-set-view-root-folder", "", 3, "textContent", "disabled", "folderId"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-share", "ml-1", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "category-toggler", 3, "click", "ngClass"], [1, "collapse-chevron"], ["draggable", "false", "href", "javascript:void(0)", "ycn-set-view-root-folder", "", 3, "textContent", "folderId"], [3, "ngTemplateOutlet"], [3, "id", "disabled", "pointer-events-none", "opacity-50"], [3, "id"], [3, "ngClass", "id"]], template: function FolderBaseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, FolderBaseComponent_Conditional_0_Template, 15, 16, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵconditionalCreate(2, FolderBaseComponent_Conditional_2_Template, 2, 1);
    } if (rf & 2) {
        i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 2, ctx.bulkActionSelectionService.idsByResourceType$) ? 0 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.folderableCollectionService.textSearchActive && ctx.folderExpansionService.isExpanded(ctx.folder.id) ? 2 : -1);
    } }, dependencies: [i5.DisabledDirective, i6.NgClass, i6.NgTemplateOutlet, i7.IconDirective, i8.TooltipDirective, i9.FolderableDirective, i10.SetViewRootFolderDirective, i6.AsyncPipe, i11.GetSharingTooltipMessage, i12.IsSharedWithOthersPipe], encapsulation: 2 });
